var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownSideFillAngleBracket(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "opacity-55",
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.12178 12.1946C9.24136 12.2478 9.37081 12.2754 9.50172 12.2754C9.63262 12.2754 9.76207 12.2478 9.88165 12.1946L13.6081 10.5347C14.5 10.0781 15.013 11.0237 14.5643 11.6015C13.7316 12.6737 11.2255 15.3903 10.082 16.6203C10.0078 16.7001 9.91804 16.7637 9.8182 16.8072C9.71836 16.8508 9.61062 16.8732 9.50172 16.8732C9.39281 16.8732 9.28507 16.8508 9.18523 16.8072C9.0854 16.7637 8.9956 16.7001 8.92146 16.6203C7.77792 15.3903 5.27187 12.6737 4.43917 11.6015C3.97933 11.0094 4.52002 10.0866 5.39529 10.5347L9.12178 12.1946Z",
    fill: "#B4C0C8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownSideFillAngleBracket);
export default __webpack_public_path__ + "static/media/downSideFillAngleBracket.32e14662196495f5e382422b3c92477c.svg";
export { ForwardRef as ReactComponent };